import * as yup from 'yup';

import {
	CODE_MIN_LENGTH,
	CODE_REQUIRED,
	CODE_TYPE,
	USERNAME_INVALID,
	USERNAME_REQUIRED,
} from './schema-errors';

export const confirmUserSchema = yup.object({
	username: yup.string().email(USERNAME_INVALID).required(USERNAME_REQUIRED),
	code: yup
		.string()
		.required(CODE_REQUIRED)
		.test('is-number', CODE_TYPE, (value) => {
			if (!/^\d+$/.test(value)) {
				return false;
			}
			return true;
		})
		.matches(/^\d{6}$/, CODE_MIN_LENGTH),
});
